import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { debounceTime, distinctUntilChanged, firstValueFrom, map, merge, mergeMap, of, startWith } from 'rxjs';
import { Dataset } from 'src/app/models/dataset.model';
import { DatasetsService } from 'src/app/services/datasets.service';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-dataset-selector-input-async',
  templateUrl: './dataset-selector-input-async.component.html',
  styleUrls: ['./dataset-selector-input-async.component.scss']
})
export class DatasetSelectorInputAsyncComponent implements OnInit {
  constructor(
    private datasetsService: DatasetsService,
    private logger: LoggingService) { }

  ngOnInit(): void {
    merge(this.datasetCtrl.valueChanges)
      .pipe(
        startWith(''),
        map((value: any) => typeof(value) === typeof('') ? value : null),
        debounceTime(500),
        distinctUntilChanged(),
        mergeMap(search => of(search)))
    .subscribe((value) => this.filterDatasets(value));
  }

  datasetSelected(event: MatAutocompleteSelectedEvent): void {
    this.selectedDatasetId = event.option.value.id;
    this.selected.emit(event.option.value.id);
  }

  clear = (): void => {
    this.datasetCtrl.setValue(undefined);
    this.selected.emit(undefined);
  };

  autocompleteDisplay = (dataset: Dataset): string => dataset ? dataset.name : undefined;

  private async loadDatasetsData() {
    try {
      this.datasets = await firstValueFrom(this.datasetsService.get_datasets());
    }
    catch (exception) {
      this.logger.logException(exception);
    }
  }

  private async filterDatasets(value: any): Promise<void> {
    try {
      value = (value || '').trim().toLowerCase();
      
      if(this.datasets === null || this.datasets === undefined) {
        await this.loadDatasetsData();
      }
      
      if (value === this.previousFilter) {
        this.filteredDatasets = await this.datasets;
        return;
      }

      this.previousFilter = value;
      this.filteredDatasets = await this.datasets.filter(x => x.name.toLowerCase().includes(value));
    }
    catch (exception) {
      this.logger.logException(exception);
    }
  }

  datasetCtrl = new UntypedFormControl();
  datasets: Dataset[];
  dataset: Dataset;
  filteredDatasets: Dataset[];
  selectedDatasetId = 0;

  private previousFilter = '';

  @Output() selected: EventEmitter<any> = new EventEmitter();
  @Output() cleared: EventEmitter<any> = new EventEmitter();  

}
